<template>
  <div id="app">
    <!-- 路由组件出口的地方 -->
    <vue-page-stack>
      <router-view></router-view>
    </vue-page-stack>
  </div>
</template>
<script>

export default {
  name: 'App'

}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

* {
  margin: 0;
  padding: 0;
}

@font-face {
  font-family: 'buding';
  src: url("https://oss.mamidiantai.com/reading/font/buding.ttf");
}

@font-face {
  font-family: 'siyuanMedium';
  src: url("https://oss.mamidiantai.com/reading/font/SourceHanSansCN-Medium.otf");
}

@font-face {
  font-family: 'siyuanHeavy';
  src: url("https://oss.mamidiantai.com/reading/font/SourceHanSansCN-Heavy.otf");
}

@font-face {
  font-family: 'siyuan';
  src: url("https://oss.mamidiantai.com/reading/font/SourceHanSansCN-Normal.otf");
}
@font-face{
  font-family: 'siyuansongBold';  
  src: url('https://oss.mamidiantai.com/reading/font/SourceHanSerifCN-Bold.subset.woff2');  
}
</style>
